import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image2 from "./images/2.jpeg";
import image1 from "./images/1.jpeg";
import image3 from "./images/3.jpeg" ;
import image4 from "./images/4.jpeg" ;
import image5 from "./images/5.jpeg";



const HackAtlas = () => {
    const images = [image1,image5,image2, image3, image4];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">HACKATHON 6.0</h2>
        <span className="section__subtitle">First place winner🥇</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🎉 Our team, <strong>Alavengers</strong>, clinched the top spot in <strong>HACKATHON 6.0</strong>, hosted by ATLAS Future Leaders-TBS Chapter at Sesame University on February 24th and 25th.
                    </p>
                    <p className='redRadio__text'>
                        🔒 It was an immersive dive into the <strong>cybersecurity domain</strong>. The hackathon theme centered on integrating AI into the file transfer process to bolster security measures.
                    </p>
                    <p className='redRadio__text'>
                        🤖 Our winning solution involved:
                    </p>
                    <ul className="achievement__list">
                        <li className='redRadio__text'>• Deploying an ML model for proactive malware detection</li>
                        <li className='redRadio__text'>• Issuing early alerts for potential threats</li>
                        <li className='redRadio__text'>• Crafting a script to automate port number changes</li>
                        <li className='redRadio__text'>• Adding layers of defense to our FTP server against vulnerabilities</li>
                    </ul>
                    <p className='redRadio__text'>
                        🛡️ This dynamic script adjusts configuration files upon server service launch, ensuring robust security measures.
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default HackAtlas;
